import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

interface typesOfwalletActivity {
    walletActivityData: any;
    loading: boolean;
    error: string | null;
}
const initialState: typesOfwalletActivity = {
    walletActivityData: [],
    loading: false,
    error: null,
};

/** Phase 12 — static Freeze: no legacy getHistory. */
export const fetchWalletActivity = createAsyncThunkWrapper<any, any>('walletActivity/fetchWalletActivity', async () => {
    return [];
});

const walletActivitySlice = createSlice({
    name: 'walletActivitySlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchWalletActivity.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchWalletActivity.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.walletActivityData = action.payload || [];
        });
        builder.addCase(fetchWalletActivity.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default walletActivitySlice.reducer;
